// CSS 绘制的 3×3 魔方面，作为品牌标（替代 emoji）
export default function CubeMark({ size = 28, className = '' }) {
  const colors = ['#E4DCCB', '#56504A', '#FF4D00', '#FF4D00', '#E4DCCB', '#2A2621', '#56504A', '#2A2621', '#E4DCCB'];
  const gap = Math.max(1, Math.round(size / 16));
  return (
    <span
      aria-hidden="true"
      className={`inline-grid ${className}`}
      style={{
        width: size,
        height: size,
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap,
        transform: 'rotate(-6deg)',
      }}
    >
      {colors.map((c, i) => (
        <span key={i} style={{ background: c, borderRadius: Math.max(1, Math.round(size / 16)) }} />
      ))}
    </span>
  );
}
